import axios from "axios";
import { API_BASE } from "@/lib/api";

export const STAFF_TOKEN_KEY = "jbk_staff_token";

export const staffApi = axios.create({ baseURL: API_BASE });

staffApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(STAFF_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

staffApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem(STAFF_TOKEN_KEY)) {
      localStorage.removeItem(STAFF_TOKEN_KEY);
      // path lives at /s/:slug — let the route protect itself.
    }
    return Promise.reject(err);
  }
);
